import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {FloatMarkupModule} from '../float-markup';
import {OverlayModule} from '../overlay';
import {ScrollToActiveModule} from '../scroll-to-active';
import {ScrollbarWithEndingBlindsModule} from '../scrollbar-with-ending-blinds';
import {TooltipModule} from '../tooltip';
import {L10nModule} from '../translate';
import {WatchlistDropdownComponent} from './watchlist-dropdown/watchlist-dropdown.component';
import {WatchlistItemComponent} from './watchlist-item.component';
import {WatchlistComponent} from './watchlist.component';
import {WatchlistFactory} from './watchlist.factory';
import {WatchlistService} from './watchlist.service';

@NgModule({
    imports: [
        CommonModule,
        L10nModule,
        FormsModule,
        OverlayModule,
        FloatMarkupModule,
        ScrollbarWithEndingBlindsModule,
        ScrollToActiveModule,
        TooltipModule
    ],
    declarations: [
        WatchlistComponent,
        WatchlistItemComponent,
        WatchlistDropdownComponent
    ],
    providers: [
        WatchlistFactory,
        WatchlistService
    ],
    exports: [
        WatchlistComponent,
        WatchlistItemComponent
    ]
})
export class WatchlistModule {}
